import { CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { KeyValueInterface } from '../../../../../../interfaces/keyValue.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { cursoResponseInterface, messageCursoResponseInterface } from '../../../../../../interfaces/curso/curso-response.interface';
import { DadosCursoResponseInterface } from '../../../../../../interfaces/curso/dados-curso-response.interface';
import { DadosCursoService } from '../../../../../../services/curso/dados-curso.service';
import { ParamCursoDataService } from '../../../../../../services/curso/param-curso-data.service';
import { PagamentoResponseInterface } from '../../../../../../interfaces/curso/pagamento-response.interface';
import { GeraPagamentoService } from '../../../../../../services/curso/gera-pagamento.service';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-gera-boleto',
  imports: [
    MatCardModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    CurrencyPipe,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    CurrencyPipe,
    MatProgressSpinnerModule
],
  templateUrl: './gera-boleto.html',
  styleUrl: './gera-boleto.css'
})
export class GeraBoleto implements AfterViewInit {

  // @Input() valor_taxa: string = '0,00';
  // @Input() pagadores: string = '';
  // @Output() boletoEmit = new EventEmitter<FormGroup>();
  // @Input() moro_no_brasil:boolean = false

  dadosCurso! : DadosCursoResponseInterface;
  dados_salvos!: cursoResponseInterface;


  _router = inject(Router);
  _dadosCurso = inject(DadosCursoService);
  _paramCursoData = inject(ParamCursoDataService);

  radiobutton_responsavel_pagar_boleto!: KeyValueInterface[];

  formGroup = new FormGroup({
    formaPagamento: new FormControl('', Validators.required),
    pagador: new FormControl('', Validators.required),
    aceite: new FormControl(false, Validators.required)
  })

  valor_taxa: string = '0.00';
  pagadores: string = '';
  nome_aluno: string = '';
  nome_curso: string = '';
  data_inclusao: string = '';
  posicao: string = '';
  qtd_vagas: string = '';
  taxa_inscricao: string = '';
  termo: string = '';
  gratuito: boolean = false;
  moro_no_brasil: boolean = false;
  loading: boolean = false;
  termo_aceito: boolean = false;
  url_boleto:string = ''
  dataResponse!:messageCursoResponseInterface;

  _geraPagamento = inject(GeraPagamentoService);


  constructor(){

  }

  ngAfterViewInit(): void {

    //Pega o objeto recebido do submit do formulario
    // let data = this._router.currentNavigation()?.extras.state;
    this.dataResponse = this._paramCursoData.getDataSubmit() as messageCursoResponseInterface;

    console.log("dados passados por param: " + this.dataResponse.pessoa.Taxa_inscricao);
      // this.dados_salvos = this.dataResponse.pessoa;

    this._dadosCurso.getDadosCurso(this.dataResponse.pessoa.DI_SIGLA, this.dataResponse.pessoa.DI_NOFER).subscribe({
      next: (data: DadosCursoResponseInterface) => {
        this.dadosCurso = data;

        this.nome_aluno = this.dataResponse.pessoa.PF_NOME.toUpperCase();
        this.valor_taxa = this.dataResponse.pessoa.Taxa_inscricao;
        this.nome_curso = this.dadosCurso.DI_NOME.toUpperCase();
        this.data_inclusao = this.dataResponse.pessoa.DI_DATAHORA;
        this.posicao = this.dataResponse.pessoa.posicao.toString();
        this._paramCursoData.qtdeVagas = this.dadosCurso.DI_NVAGMAX.toString();
        // this.termo = this.dataResponse.pessoa.termo_fluxo;
        this.gratuito = this.dadosCurso.gratuito === 'SIM' ? true : false;
        //this.pagadores = this.dataResponse.pessoa.COMPROVANTE_EMPRESA;

        this.habilita_quem_realizara_pagamento(this._paramCursoData.forma_pagamento_selecionada)
        this.habilita_forma_pagamento(this._paramCursoData.getMoroNoBrasil());

        // console.log(this.termo);
      }
    });
  }

  habilita_forma_pagamento(status: boolean){

    if(status){

      this.formGroup.get('formaPagamento')?.enable();
    }else{

      this.formGroup.get('formaPagamento')?.setValue('10');
      this.formGroup.get('formaPagamento')?.disable();
    }
  }

  habilita_quem_realizara_pagamento(pagador: string){

    this.radiobutton_responsavel_pagar_boleto = [];

    switch (pagador) {
      case 'ALUNO':
        this.radiobutton_responsavel_pagar_boleto.push({
          key: 'Aluno',
          value: 'ALUNO'
        })
        this.formGroup.get('pagador')?.setValue('ALUNO');
        this.formGroup.get('pagador')?.disable();
        break;

      case 'TERCEIRO':
        this.radiobutton_responsavel_pagar_boleto.push(
          {
            key: 'Aluno',
            value: 'ALUNO'
          },
          {
            key: 'Pessoa Física',
            value: 'TERCEIRO'
          }
        )
        break;

      case 'EMPRESA':
        this.radiobutton_responsavel_pagar_boleto.push(
          {
            key: 'Aluno',
            value: 'ALUNO'
          },
          {
            key: 'Empresa',
            value: 'EMPRESA'
          }
        )
        break;

      case 'MISTO':
        this.radiobutton_responsavel_pagar_boleto.push(
          {
            key: 'Pessoa Física',
            value: 'TERCEIRO'
          },
          {
            key: 'Empresa',
            value: 'EMPRESA'
          }
        )
        break;

      default:
        break;
    }
  }

  get aceite(){

    return this.formGroup.get('aceite')?.value;
  }

  finalizar() {

    this.loading = true;

    if(this.formGroup.get('formaPagamento')?.value){

      this._geraPagamento.geraPagamento(

        this._paramCursoData.getDataSubmit().pessoa.DI_SIGLA,
        this._paramCursoData.getDataSubmit().pessoa.DI_NOFER,
        this._paramCursoData.getDataSubmit().pessoa.PF_RG,
        this.formGroup.get('formaPagamento')?.value as string,
        this.formGroup.get('pagador')?.value as string
      ).subscribe({
        next: (response: PagamentoResponseInterface) => {

          this.loading = false;
          this.termo_aceito = true;
          this.url_boleto = response.URLPagamento[0];
          this._paramCursoData.urlBoleto = this.url_boleto;

          this._router.navigate(['curso-cadastrado-sucesso/info']);
        },
        error: (error) => {

          this.loading = false;
          this.termo_aceito = false;
          console.log(error);
        }
      })
    }

  }

}
